export default __webpack_public_path__ + "static/media/img001.b392df96.png";